/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";

const ImageCover = (props) => {

    const { displayWidth, displayHeight } = props;
    const { selectedImage } = useContext(ImageEditContext);
    const { url, cover_position = "center center" } = selectedImage || {};
    let { width = 0, height = 0 } = selectedImage || {};
    // const defaultWidth = '100%'
    const defaultWidth = "100%";
    const defaultHeight = 160;
    // use defaults if 0
    width = (width === 0) ? defaultWidth : width;
    height = (height === 0) ? defaultHeight : height;
    // use display width/height if supplied
    width = displayWidth ? displayWidth : width;
    height = displayHeight ? displayHeight : height;
    const cover_image_style = {
        backgroundImage: `url('${url}?t=${Date.now()}')`,
        backgroundPosition: `${cover_position}`,
        width: width,
        height: height,
        borderRadius: "8px",
        // aspectRatio: 'auto'
    };

    return (
        <div
            id='simplicity-cover-image'
            className='simplicity-cover-image-edit cover'
            style={cover_image_style}
        />
    );
};

export { ImageCover };
